<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' ></NavBar>
    <div class="paddingContent">

      <div class="tableWrap">
        <table class="customizeTable">
          <thead>
          <tr>
            <th v-for="(thItem, thIndex) in bannerTable" :key="thIndex" class="normal_font" style="width:3.6rem;">{{thItem.label}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-show="showNoneTips">
            <td class="normal_font" colspan="6">暫無數據</td>
          </tr>
          <tr v-for="(item, index) in bannerList" :key="index">
            <td class="mainImgWrap normal_font" style="justify-content:center">
             {{	item.signDate }}
            </td>
            <td class="normal_font">{{item.region}}</td>
            <td class="normal_font delDiary">
             
              <span @click="goSign(item.id)">查看評論</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
	data() {
		return {
			navBlock: "签到 ",
			navtitle: "签到列表",
			bannerList: [],
			bannerTable: [
				{
					prop: "signDate",
					label: "JJ簽到時間",
					width: "200",
				},
				{
					prop: "region",
					label: "JJ簽到位置",
					width: "200",
				},
				{
					prop: "operate",
					label: "詳情",
					width: "180",
				},
			],
			currentPage: 1,
			total: 20,
			showNoneTips: false,
			dialogVisible: false,
		};
	},
	created() {
		this.getBannerList();
	},

	methods: {
		// 获取banner列表
		getBannerList() {
			this.$get(
				`/request/earth/sign/list?page=${this.currentPage}&size=10`,
				{},
				this.$GLOBAL.jsonConfig
			).then((res) => {
				if (res.code === "00000") {
					if(res.data.list.length === 0){
						this.showNoneTips = true;
						return;
					}
					res.data.list.forEach((v) => {
						v.signDate = this.$getTime(v.signDate);
					});
					this.bannerList = res.data.list;
					this.total = res.data.allRow;
				} else {
					this.$propMessage(res.message, "error");
				}
			});
		},
		goSign(e) {
			this.$router.push(`/signDetail?id=${e}`);
		},

		// 分页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getBannerList();
		},
	},
	components: {
		NavBar,
		DiaMess,
	},
};
</script>
<style lang="less" scoped>
.content {
	.paddingContent {
		.MenuBtnWrap {
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/sign/signList.vue